import http from "./http";
const baseUrl = "/appuser-web";

// 保存用户的电子签名url
const saveSign = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/user/saveSignUrl", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// 获取某个用户的签名
const getSign = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/user/getSignUrl", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 获取用户列表 */
const getSysUserAccountService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .get(baseUrl + "/user", reqParam, true)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 新增用户 */
const addSysUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/user", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 修改用户信息 */
const modifySysUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .put(baseUrl + "/user", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

/* 冻结用户 */
const deleteSysUserService = (reqParam) => {
  return new Promise((resolve, reject) => {
    http
      .delete(baseUrl + "/user", reqParam, false)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getSupplierItemsServiceUrl = "/supplier/list";
const createSupplierItemServiceUrl = "/supplier";
const deleteSupplierItemsServiceUrl = "/supplier";
const editSupplierItemServiceUrl = "/supplier";

/**
 * 获取供应商列表数据
 */
const getSupplierItemsService = (params) => {
  return http.post(baseUrl + getSupplierItemsServiceUrl, params, false);
};
/**
 * 创建一条新的供应商数据
 */
const createSupplierItemService = (params) => {
  return http.post(baseUrl + createSupplierItemServiceUrl, params, false);
};

/**
 * 删除供应商数据，可一次删除多条
 */
const deleteSupplierItemsService = (params) => {
  return http.delete(baseUrl + deleteSupplierItemsServiceUrl, params, false);
};

/**
 * 修改一条新的供应商数据
 */
const editSupplierItemService = (params) => {
  return http.put(baseUrl + editSupplierItemServiceUrl, params, false);
};

export {
  getSysUserAccountService,
  deleteSysUserService,
  addSysUserService,
  modifySysUserService,
  saveSign,
  getSign,
  getSupplierItemsService,
  createSupplierItemService,
  deleteSupplierItemsService,
  editSupplierItemService,
};
